import React from "react"
import buildClassList from "../utilities/buildClassList"
import ReactHtmlParser from "react-html-parser"

const Paragraph = ({ text, replace, bold, className, ...rest }) => {

  const htmlParserTransform = (node, index) => {
    if (node.type === "tag" && node.name === "a") {
      const { href, datatype } = node.attribs
      if (datatype === "link") {
        return (
          <a
            key={index}
            href={href}
            className="text-blue-500 hover:text-blue-600 underline active:text-blue-700"
          >{node.children[0].data}</a>
        )
      }
    }
  }

  let setText = text,
    link = ""

  if (replace.length > 0) {
    replace.map((item) => {
      if (item.type === "link") {
        link = `<a datatype="link" target="_blank" rel="noopener"  href="${item.href}">${item.text}</a>`
        setText = setText.replace(item.key, link)
      }
      if (item.type === "doubleQuotes") {
        link = '"' + item.text + '"'
        setText = setText.replace(item.key, link)
      }
      if (item.type === "simpleText") {
        link = item.text
        setText = setText.replace(item.key, link)
      }
      if (item.type === "bold") {
        link = "<strong>" + item.text + "</strong>"
        setText = setText.replace(item.key, link)
      }
      if (item.type === "component") {
        link = item.component
        setText = setText.replace(item.key, link)
      }
      return null
    })
  }

  let returnedJSX = ReactHtmlParser(setText, { decodeEntities: true, transform: htmlParserTransform })

  return (
    <p className={buildClassList([className, bold ? "font-bold " : ""])} {...rest}>{returnedJSX}</p>
  )
}

export default Paragraph
